'use client';

import { useTranslation } from 'react-i18next';

import { useToast } from '@/components/ui/Toast/hook';
import { ToastSuccess } from '@/components/ui/Toast/ToastSuccess/ToastSuccess';

export const useCopyUrl = (url?: string) => {
  const { t } = useTranslation();
  const { toast, openToast } = useToast(
    <ToastSuccess message={t('Alert.link_copied_message')} />,
    111
  );

  const onCopy = () => {
    const computedLink = url ?? window.location.href;

    navigator.clipboard.writeText(computedLink).then(() => openToast());
  };

  return { toast, onCopy };
};
